import { colors, mediaQueries, breakpoints } from '@everlywell/leaves';
import styled, { css } from 'styled-components';

const Layout = styled.div<{ isV2Page?: boolean }>`
  display: flex;
  flex-direction: column;

  ${mediaQueries.forUltraWideDesktopUp} {
    max-width: ${breakpoints.forUltraWideDesktopUp}px;
    margin-left: auto;
    margin-right: auto;
  }

  ${({ isV2Page }) =>
    isV2Page
      ? css``
      : css`
          *:focus {
            outline-color: ${colors.teal4};
          }
        `}
`;

export { Layout };
